import _ from 'lodash';

import { TableEdits } from 'components/settings/tables-rooms/TablesAndRoomsBody';
import { logger } from '@tock/logging';
import AppConstants from 'constants/AppConstants';

interface State {
  currentTables?: TableEdits;
  initialTables?: TableEdits;
}

const initialState: State = {
  currentTables: undefined,
  initialTables: undefined,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.TABLE_EDITS_INITIALIZE: {
      return {
        ...state,
        currentTables: payload,
        initialTables: payload,
      };
    }

    case AppConstants.TABLE_EDITS_UPDATE_TABLE_LOCATION: {
      if (!state.currentTables) {
        logger.error('Updated table location without initializing tableEdits.');
        return state;
      }
      const currentTable = state.currentTables[payload.tableId];
      if (!currentTable) {
        logger.error(`No table with id ${payload.tableId} found in tableEdits`);
        return state;
      }
      // If the location didn't change, don't trigger an unnecessary rerender
      if (_.isEqual(currentTable.location, payload.tableLocation)) {
        return state;
      }
      return {
        ...state,
        currentTables: {
          ...state.currentTables,
          [payload.tableId]: {
            ...currentTable,
            location: payload.tableLocation,
          },
        },
      };
    }

    default:
      return state;
  }
}
